export const statuses = [
  { id: 1, name: 'Новая'},
  { id: 2, name: 'В пути'},
  { id: 3, name: 'В ожидании'},
  { id: 4, name: 'Согласовано ТМ '},
  { id: 5, name: 'Отклонено ТМ'},
  { id: 6, name: 'К исполнению'},
  { id: 7, name: 'Отклонено СБ'},
  { id: 8, name: 'Отклонено ДИСТР'},
  { id: 9, name: 'Подтверждено'},
  { id: 10, name: 'Исполнено'},
  { id: 11, name: 'Не исполнено'},
  { id: 12, name: 'Отменено'},
];

export const TX_STATUS_NEW = statuses[0];
export const TX_STATUS_APPROVED_BY_TM = statuses[1];
export const TX_STATUS_APPROVED_BY_SB = statuses[2];
export const TX_STATUS_ON_WAY = statuses[3];
export const TX_STATUS_WAITING = statuses[4];
export const TX_STATUS_CONFIRMED = statuses[5];
export const TX_STATUS_DONE = statuses[6];
export const TX_STATUS_CANCELED = statuses[7];
export const TX_STATUS_DECLINED_BY_TM = statuses[8];
export const TX_STATUS_DECLINED_BY_SB = statuses[9];
export const TX_STATUS_DECLINED_BY_DISTR = statuses[10];